import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * テキストアイコンボタン
 *【内容:text:string】
 *【アイコンタイプ:icon:string】
 *【位置:position:string】
 *【非活性:disabled:boolean】
 *【2ndデザイン:secondary:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-text-with-icon-button',
  templateUrl: './text-with-icon-button.html',
  styles: [`
    
  `]
})
export class TextWithIconButton extends BaseWidget {
  /**
   * 内容
   */
  @Input() text:string

  /**
   * アイコンタイプ
   */
  @Input() icon:string

  /**
   * 位置
   */
  @Input() position:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * 2ndデザイン
   */
  @Input() secondary:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * デザイン状態を取得する
   *
   */
  get isSecondary() {
    if (!!this.secondary) {
      return true
    } else {
      return
    }
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/text-with-icon-button/text-with-icon-button.component.ts